import { AppBundle } from 'api/optimalprint-sdk.d';
import { cloneDeep } from 'lodash';

const STUDIO_SELECTION_POSTERS_TYPE_ID = 173;
const STUDIO_SELECTION_CANVAS_TYPE_ID = 174;
const STUDIO_SELECTION_POSTER_FRAMES_TYPE_ID = 175;
const OP_PLUS_SUBSCRIPTION_PRODUCT_TYPE_ID = 179;

const CATEGORY_FUNERAL_INV_ID = 655;
const CATEGORY_TYC_FUNERAL_ID = 420;
const CATEGORY_FUNERAL_ORDER_OF_SERVICE = 564;
const CATEGORY_FUNERAL_MENU = 563;

const POSTER_FRAME_TYPE_ID = 100;
const POSTER_HANGER_TYPE_ID = 101;
const POSTER_ARTISTIC_PRODUCT_TYPE_ID = 84;
const ACTIVITY_POSTER_TYPE_ID = 99;

const NOT_ALLOWED_CATEGORIES = [
  CATEGORY_FUNERAL_INV_ID,
  CATEGORY_TYC_FUNERAL_ID,
  CATEGORY_FUNERAL_ORDER_OF_SERVICE,
  CATEGORY_FUNERAL_MENU,
];

const NOT_EDITABLE_PRODUCT_TYPE_IDS = [
  POSTER_HANGER_TYPE_ID,
  POSTER_FRAME_TYPE_ID,
  POSTER_ARTISTIC_PRODUCT_TYPE_ID,
  ACTIVITY_POSTER_TYPE_ID,
  STUDIO_SELECTION_POSTERS_TYPE_ID,
  STUDIO_SELECTION_CANVAS_TYPE_ID,
  STUDIO_SELECTION_POSTER_FRAMES_TYPE_ID,
  OP_PLUS_SUBSCRIPTION_PRODUCT_TYPE_ID,
];

const ORDER_PLACED = 'order_placed';
const ORDER_PRINTED = 'order_printed';
const ORDER_DISPATCHED = 'order_dispatched';

const ALLOWED_ORDER_STATUSES = [ORDER_PLACED, ORDER_PRINTED, ORDER_DISPATCHED];

const filterHighlightsItems = (orders: AppBundle.Api.Entity.Order.V1.Order[]) => {
  const result = cloneDeep(orders).filter((order) => {
    return ALLOWED_ORDER_STATUSES.indexOf(order.productionStatus) !== -1;
  });

  result.forEach((order) => {
    order.items = order.items.filter((item) => {
      const categoryIsValidToBeShown = item.categoryId ? NOT_ALLOWED_CATEGORIES.indexOf(item.categoryId) === -1 : false;
      const productTypeIdIsValidToBeShown = NOT_EDITABLE_PRODUCT_TYPE_IDS.indexOf(item.productTypeId) === -1;
      return item.canReorder && categoryIsValidToBeShown && productTypeIdIsValidToBeShown;
    });
  });
  return result;
};

export default filterHighlightsItems;
